export default __webpack_public_path__ + "static/media/background_Wheel.34f9b926.jpg";